import { render, staticRenderFns } from "./BookingSummarySidebar.vue?vue&type=template&id=68b6634e"
import script from "./BookingSummarySidebar.vue?vue&type=script&lang=js"
export * from "./BookingSummarySidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports